import { isEmpty } from "@utils";
import { inject, observer } from "mobx-react";
import { FileUpload } from "primereact/fileupload";
import { Image } from "primereact/image";
import { useEffect, useRef } from "react";
import { useParams } from "react-router-dom";

import "./style.scss";

const TextBlock = inject("mainStore")(
    observer(({ mainStore, dataId, item, keyData, isDisabled, value, handleDataChange, siteId, className, urlUpload, data = false, noLabel = false, noRemove = false, changeableData, error = false }) => {
        const { firstParam } = useParams();
        const _fileUpload = useRef(null);

        const isTrash = noRemove ? true : item && item.pathStorage && changeableData[item.pathStorage] ? true : false;
        const pathToStorage = `${firstParam === "offers" ? "vendors" : "offers"}`;
        const outPath = `${pathToStorage}/${item.pathStorage}`;

        const imageData = value && !isEmpty(value) ? value : false;

        const _removeFile = async (data, index) => {
            await mainStore.postByUrl("/uploader/remove_file", { path: data });
            handleDataChange("", dataId.join("."));
        };

        const _uploadHandler = async (file) => {
            let url = outPath;

            console.log(file);

            let formData = new FormData();
            file.files.forEach((file) => {
                formData.append("file", file);
            });

            const response = await mainStore.uploadImage(url, formData);
            if (response && response.success) {
                if (response && response.data) {
                    handleDataChange(response.data["Location"], dataId.join("."));
                    file.options.clear();
                }
            }
        };

        const dragAndDrop = () => {
            return <span>Перетащите или выберите файл</span>;
        };

        return (
            <div key={keyData} className={`detail__item two-width ${className}`}>
                {!noLabel ? (
                    <label className={dataId.join("-")} htmlFor={keyData} data-pr-tooltip={item.label}>
                        {item.label}
                        {item.required ? "*" : ""}
                    </label>
                ) : null}

                {!isTrash ? (
                    <div className="image-container">
                        <FileUpload
                            data-id={dataId.join(".")}
                            id={`${keyData}`}
                            disabled={isDisabled}
                            ref={_fileUpload}
                            mode={"basic"}
                            name="file[]"
                            url="/api/upload"
                            accept="image/*"
                            maxFileSize={5 * 1024 * 1024}
                            customUpload={true}
                            uploadHandler={_uploadHandler}
                            auto
                            chooseOptions={{ icon: "pi pi-upload", className: "btn", label: "Выбрать" }}
                            uploadLabel="Загрузить"
                            cancelLabel="Очистить"
                            emptyTemplate={dragAndDrop}
                        />
                        <ImageItem type={item.pathStorage} keyData={keyData} data={imageData} ind={0} key={0} removeFile={_removeFile} noRemove={true} preview={false} error={error} />
                    </div>
                ) : (
                    <ImageItem type={item.pathStorage} keyData={keyData} data={imageData} ind={0} key={0} removeFile={_removeFile} noRemove={noRemove} />
                )}
            </div>
        );
    }),
);
export default TextBlock;

const ImageItem = ({ data, removeFile, ind, noRemove, preview = true, keyData = false, type = "", error = false }) => {
    const icon = (
        <i
            className="pi pi-trash"
            onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                removeFile(data, ind);
            }}
        ></i>
    );

    useEffect(() => {
        const elem1 = document.querySelector(`[data-id="${keyData}"]`);
        const elem2 = document.getElementById(`place_${keyData}`);

        if (!elem1 || !elem2) return;

        const hideElem2 = () => {
            elem2.classList.add("hidden");
        };

        const showElem2 = () => {
            elem2.classList.remove("hidden");
        };

        elem1.addEventListener("mouseenter", hideElem2);
        elem1.addEventListener("mouseleave", showElem2);

        return () => {
            elem1.removeEventListener("mouseenter", hideElem2);
            elem1.removeEventListener("mouseleave", showElem2);
        };
    }, [keyData]);
    // console.log(keyData);

    return (
        <div className={`imageItem ${type}`}>
            {data ? (
                <Image src={data} indicatorIcon={noRemove ? null : icon} alt="Image" width={80} preview={preview} downloadable={true} />
            ) : (
                <div className={`placeholder ${error ? "error" : ""}`} id={`place_${keyData}`}>
                    <i className="pi pi-plus-circle" />
                    <span>Перетащите или выберите файл</span>
                </div>
            )}
        </div>
    );
};
